import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Office Address Section */}
        <div className="footer-section about">
          <h2>Our Office</h2>
          <p>
          26 Akinleigh Street, Lekki Phase 1
            <br /> Lagos, Nigeria
          </p>
          <p>Phone: +2348136322661</p>
          <p>Email: Admin@geegaresources.com</p>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section links">
          <h2>Quick Links</h2>
          <ul>
            <li>
              {/* <a href="#about">About Us</a> */}
              <Link to={"/about"} className="linkdec">About Us</Link>
            </li>
            <li>
              {/* <a href="#services">Services</a> */}
              <Link to={"/service"} className="linkdec">Services</Link>
            </li>
            <li>
              {/* <a href="#contact">Contact</a> */}
              <Link to={"/gallery"} className="linkdec">Gallery</Link>
            </li>
            <li>
              {/* <a href="#careers">Careers</a> */}
              <Link to={"/board"} className="linkdec">Directors</Link>
            </li>
          </ul>
        </div>

        {/* Social Media Section */}
        <div className="footer-section social">
          <h2>Follow Us</h2>
          <div className="social-links">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="ri-facebook-fill"></i>
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="ri-twitter-fill"></i>
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="ri-instagram-line"></i>
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="ri-linkedin-box-fill"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="footer-bottom">
        &copy; 2024 Geega resources. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
